import { Component, OnInit, ViewChild, Inject, AfterViewInit, OnDestroy } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-total-servicios-grupo',
  templateUrl: './total-servicios-grupo.component.html',
  styleUrls: ['./total-servicios-grupo.component.scss']
})
export class TotalServiciosGrupoComponent implements OnInit, OnDestroy, AfterViewInit {

  // Variables DataTable //
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   */
  constructor(@Inject(MAT_DIALOG_DATA) private _data, private _cartera: CarteraService) { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.dtOptions = {
      scrollY: '383px',
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      order: [0, 'desc'],
      columns: [
        {
          data: 'N_Historia'
        },
        {
          data: 'color_servicio',
        },
        {
          data: 'Fecha'
        },
        {
          data: 'Hora'
        },
        {
          data: 'persona_llamada'
        },
        {
          data: 'telefono_llamada'
        },
        {
          data: 'celular_notificacion'
        },
        {
          data: 'Hora_Llegada'
        },
        {
          data: 'Medico'
        },
        {
          data: 'Motivo'
        },
        {
          data: 'Diagnostico'
        },
        {
          data: 'Auxiliar'
        },
        {
          data: 'Conductor'
        },
        {
          data: 'Tipo_Servicio'
        }
      ],
      responsive: true
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._cartera.VerServiciosTotalesxGrupo(this._data.base_datos, this._data.search_code).subscribe((data: any) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Renderiza DataTable
   */
  public renderer(): void{
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  

}
